const capitaliseStringFirstLetter = (value: string) => {
  return value[0].toUpperCase() + value.substring(1);
};

export default capitaliseStringFirstLetter;
